import { Link } from 'react-router-dom';
import { events } from '@/mocks/events';

const debunks = events.filter((e) => e.status === '辟谣中' || e.status === '已辟谣');

const steps = [
  {
    n: '01',
    icon: 'ri-archive-line',
    title: '归拢材料',
    desc: '把同一事件的聊天、转账、录音按类型与时间收纳，保留来源说明。',
  },
  {
    n: '02',
    icon: 'ri-arrow-left-right-line',
    title: '双方并列',
    desc: '收到反驳素材后不删原档，而是把正反证据放在同一时间线里对照。',
  },
  {
    n: '03',
    icon: 'ri-check-double-line',
    title: '如实标记',
    desc: '依证据完整度更新状态：持续更新 / 辟谣中 / 已辟谣，不预判结论。',
  },
];

export default function TruthMethod() {
  return (
    <section className="max-w-[1440px] mx-auto px-4 md:px-6 lg:px-10 py-12 md:py-16">
      {/* 辟谣反锤横幅 */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 overflow-hidden rounded-2xl bg-foreground-950">
        <div className="relative p-6 md:p-10 flex flex-col justify-center min-h-[260px]">
          <div className="pointer-events-none absolute -right-10 -bottom-10 w-52 h-52 rounded-full bg-accent-500/20 blur-2xl"></div>
          <span className="inline-flex items-center gap-1.5 text-xs text-accent-400 bg-accent-500/15 px-3 py-1 rounded-full w-fit">
            <i className="ri-flag-2-fill"></i>真相核对区
          </span>
          <h3 className="mt-4 font-display font-black text-background-50 text-2xl md:text-3xl">
            辟谣反锤，同框对质
          </h3>
          <p className="mt-3 text-background-200 leading-relaxed max-w-lg text-sm md:text-base">
            网络传言常常「反转再反转」。我们不对单方截图下结论，而是把当事人的回应、打款回执与澄清材料
            <span className="text-accent-300">并列陈列</span>，让证据自己说话。
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            {debunks.map((e) => (
              <Link
                key={e.slug}
                to={`/event/${e.slug}`}
                className="inline-flex items-center gap-1.5 text-xs text-background-100 bg-background-50/10 hover:bg-background-50/20 px-3 py-1.5 rounded-full transition-colors"
              >
                <span className={`w-1.5 h-1.5 rounded-full ${e.status === '已辟谣' ? 'bg-secondary-400' : 'bg-accent-400'}`}></span>
                {e.category}
              </Link>
            ))}
          </div>
        </div>

        {/* 工作方法 */}
        <div className="bg-background-100/60 p-6 md:p-10">
          <div className="flex items-center justify-between gap-3 flex-wrap">
            <h4 className="font-display font-black text-foreground-950 text-xl md:text-2xl">我们的工作方法</h4>
            <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
              <i className="ri-shield-check-line text-accent-600"></i>证据优先
            </span>
          </div>
          <div className="mt-6 space-y-4">
            {steps.map((s) => (
              <div key={s.n} className="flex gap-4">
                <div className="flex flex-col items-center">
                  <span className="inline-flex items-center justify-center w-11 h-11 rounded-lg bg-accent-100 text-accent-700 text-xl shrink-0">
                    <i className={s.icon}></i>
                  </span>
                  {s.n !== steps[steps.length - 1].n && <span className="w-px flex-1 bg-background-300 my-1"></span>}
                </div>
                <div className="pb-2">
                  <p className="font-display font-bold text-foreground-950 flex items-center gap-2">
                    <span className="text-accent-600 font-display">{s.n}</span>
                    {s.title}
                  </p>
                  <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}